<li
  class="breadcrumb-item"
  [class.selected]="selected"
  [class.inactive]="inactive"
  [attr.aria-current]="selected ? 'page' : null"
>
  <div class="breadcrumb-content">
    <hyperkit-typography 
      *ngIf="link" 
      [routerLink]="link" 
      variant="label2" 
      align="center" 
      color="inherit"
      class="breadcrumb-text"
    >
      {{text}}
    </hyperkit-typography>
    
    <hyperkit-typography 
    *ngIf="!link" 
    variant="label2" 
    align="center" 
    color="inherit"
    class="breadcrumb-text"
    role="button"
    tabindex="0"
    (click)="clicked.emit()"
    (keydown)="onKeydown($event)"
  >
    {{ text }}
  </hyperkit-typography>
    </div>
</li>